import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type UpdateCollectionIssueRequest = {
  id: number;
  addressUnitNo: string;
  addressStreetNo: string;
  addressStreetName: string;
  addressSuburbName: string;
  addressStateCode: string;
  addressPostCode: string;
};

export type UpdateCollectionIssueResponse = {
  successful: boolean;
};

export const updateCollectionIssue = async (request: UpdateCollectionIssueRequest) => {
  const response = await executeApiRequest(
    () => axios.put<UpdateCollectionIssueResponse>("/collectionevents/update", request, { withCredentials: true }),
    false
  );
  return response?.data;
};
